module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPgAAABECAIAAAAju29SAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEkSURBVHhe7dYhTgNhFEbR2VqX0QWwgFlDVRNsHYJgCKlANakiDb5BVNazDahqGMEG/ntOPvfsFW/avHzMu4PZ2JvWm7fV/GQ29oRuiQndEluEvj9dvq7fZmNs+/p5b3sR+u32A6N4Pp7vbQudYQmdBKGTIHQShE6C0EkQOglCJ0HoJAidBKGTIHQShE6C0EkQOglCJ0HoJAidBKGTIHQShE6C0EkQOglCJ0HoJAidBKGTIHQShE6C0EkQOglCJ0HoJAidBKGTIHQShE6C0EkQOglCJ0HoJAidBKGTIHQShE6C0EkQOglCJ0HoJAidBKGTIHQShE6C0EkQOglCJ0HoJPwb+sPj+7w7mI2xv20vQjcbdUK3xIRuiU370+X2s5uNvOP5FxxjfT5tSJ/MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_number_avatar.png
// module id = ZwgB
// module chunks = 0